import { useHeroContentQuery, useSiteAlertQuery } from 'generated/sanity-graphql';
import { useOffersDataset } from 'hooks/use-offers-dataset';
// Don't apply any conditional logic here, as this will determine which hooks are run.
// Use brand or platform specific files for special cases.

const aboveTheFold = [useHeroContentQuery, useSiteAlertQuery, useOffersDataset];

export default aboveTheFold;
